<template>
  <div>
    <div class="d-flex align-items-center justify-content-between details-content py-12 px-16">
      <div class="d-flex align-items-center">
        <div class="left-icon mr-1 custom-icon ">
          <icon name="details"/>
        </div>
        <div class="widget-name">Details</div>
      </div>
      <div
        :class="[isOpen ? 'rotate-icon':'un-rotate']"
        class="custom-icon"
      >
        <icon name="chevron"/>
      </div>
    </div>
    <div v-show="isOpen">
      <slot />
    </div>
  </div>
</template>
<script>
import PanelHeading from '@/components/PanelHeading/PanelHeading';

export default{
  components: {
    'panel-heading': PanelHeading,
  },
  props: {
    isOpen: [Number, String, Boolean],
  },
};
</script>
